"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("../style/index"));

var _IconButton = _interopRequireDefault(require("../../IconButton"));

var _createStyled = require("../../../utils/createStyled");

var _icon = _interopRequireDefault(require("../views/icon.c"));

var _checkedIcon = _interopRequireDefault(require("../views/checkedIcon.c"));

function template() {
  var _this$props = this.props,
      _this$props$theme = _this$props.theme,
      theme = _this$props$theme === void 0 ? {} : _this$props$theme,
      label = _this$props.label,
      _this$props$className = _this$props.className,
      className = _this$props$className === void 0 ? '' : _this$props$className,
      disabled = _this$props.disabled,
      name = _this$props.name,
      checked = _this$props.checked,
      value = _this$props.value,
      attribute = _this$props.attribute,
      children = _this$props.children,
      checkedIcon = _this$props.checkedIcon,
      icon = _this$props.icon,
      onChange = _this$props.onChange,
      styles = this.compileStyled(_index["default"]),
      id = this.props.id || this.id;
  var labelContent = null,
      img,
      iconContent;

  if (children) {
    labelContent = _react["default"].createElement(_createStyled.Styled.Div, {
      styles: styles.labelText
    }, children);
  } else {
    labelContent = _react["default"].createElement(_createStyled.Styled.Div, {
      styles: styles.labelText
    }, label);
  }

  if (checked) {
    img = checkedIcon || theme.appearanceChecked || _react["default"].createElement(_IconButton["default"], {
      iconFx: false,
      rippleColor: theme.checkedRippleColor,
      disabled: disabled
    }, _react["default"].createElement(_checkedIcon["default"], {
      fill: theme.checkedIconColor
    }));
  } else {
    img = icon || theme.appearance || _react["default"].createElement(_IconButton["default"], {
      iconFx: true,
      rippleColor: theme.rippleColor,
      disabled: disabled
    }, _react["default"].createElement(_icon["default"], {
      fill: theme.iconColor
    }));
  }

  if (typeof img === 'string') {
    iconContent = _react["default"].createElement(_IconButton["default"], {
      icon: img,
      iconFx: !checked,
      rippleColor: checked ? theme.checkedRippleColor : theme.rippleColor,
      disabled: disabled
    });
  } else {
    iconContent = img;
  }

  return _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.root,
    className: className
  }, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.wrapper
  }, _react["default"].createElement(_createStyled.Styled.Input, {
    onChange: onChange,
    disabled: disabled,
    checked: !!checked,
    value: value,
    id: id,
    name: name,
    type: "checkbox",
    styles: styles.field,
    ref: this._createRef,
    "data-qa-node": attribute,
    "data-qa-value": !!checked
  }), _react["default"].createElement(_createStyled.Styled.Label, {
    styles: styles.label,
    htmlFor: id
  }, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.iconWrapper
  }, iconContent), labelContent)));
}